import { render, staticRenderFns } from "./_Movements.vue?vue&type=template&id=721ffe3c&scoped=true"
import script from "./_Movements.vue?vue&type=script&lang=js"
export * from "./_Movements.vue?vue&type=script&lang=js"
import style0 from "./_Movements.vue?vue&type=style&index=0&id=721ffe3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ffe3c",
  null
  
)

export default component.exports